import { Component, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector     : 'layout',
    templateUrl  : './layout.component.html',
    styleUrls    : ['./layout.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LaundryClientAreaComponent implements OnDestroy
{
    isSidebarOpen = false;
    isDesktopSidebarCollapsed = false;
    private _routerSub: Subscription;

    constructor(private _router: Router)
    {
        this._routerSub = this._router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.isSidebarOpen = false;
            });
    }

    ngOnDestroy(): void {
        this._routerSub?.unsubscribe();
    }

    toggleSidebar(): void {
        const isMobile = window.innerWidth < 768;
        
        if (isMobile) {
            this.isSidebarOpen = !this.isSidebarOpen;
        } else {
            this.isDesktopSidebarCollapsed = !this.isDesktopSidebarCollapsed;
        }
    }
}
